export const creditCardsValidation = {
    data() {
        return {
            cardInfo: {
                cardholderName: '',
                nickname: '',
                firstName: '',
                lastName: '',
                cardNumber: '',
                expMonth: '',
                last_four: '',
                expDate: '',
                expYear: '',
                cvc: '',
                _token: this.csrf
            },
            validateRules: {
                cardholderName: false,
                cardNumber: false,
                expDate: false,
                cvc: false
            },

            checkCard: false
        }
    },
    methods: {
        validationCardHolder() {
            const cardholderNameRegex = /^(?=.{1,24}$)(?:[a-zA-Z.`'-]+(?:\s|$)){1,3}[a-zA-Z.`'-]+$/
            return !cardholderNameRegex.test(this.cardInfo.cardholderName)
                ? (this.validateRules.cardholderName = true)
                : (this.validateRules.cardholderName = false)
        },
        validationCardNumber() {
            const cardNumberWithoutSpaces = this.cardInfo.cardNumber.replace(/\s/g, '')
            const cardNumberRegex = /^(?! )\d{13,19}$/
            const digits = cardNumberWithoutSpaces.split('').reverse().map(Number)
            const checksum = digits.reduce((sum, digit, index) => {
                if (index % 2 === 1) {
                    const doubled = digit * 2
                    return sum + (doubled > 9 ? doubled - 9 : doubled)
                }
                return sum + digit
            }, 0)
            const isCardNumberValid = cardNumberRegex.test(cardNumberWithoutSpaces)
            const isChecksumValid = checksum % 10 === 0

            this.validateRules.cardNumber = !isCardNumberValid || !isChecksumValid
            return isCardNumberValid && isChecksumValid
        },
        validationExpMonth() {
            const expMonthRegex = /(^(?:0[1-9]|1[0-2])$)/
            return !expMonthRegex.test(this.cardInfo.expMonth)
                ? (this.validateRules.expMonth = true)
                : (this.validateRules.expMonth = false)
        },
        validationExpYear() {
            const currentYear = new Date().getFullYear()
            return this.cardInfo.expYear >= currentYear
                ? (this.validateRules.expYear = false)
                : (this.validateRules.expYear = true)
        },
        validationCVC() {
            const CvcRegex = /^[0-9]{3,4}$/
            return !CvcRegex.test(this.cardInfo.cvc)
                ? (this.validateRules.cvc = true)
                : (this.validateRules.cvc = false)
        },
        validationExpDate() {
            const value = this.cardInfo.expDate.split('/')
            const month = value[0]
            const year = value[1]
            const currentYearLastTwoDigits = new Date().getFullYear() % 100
            const isMonthValid = parseInt(month) <= 12
            const isYearValid = parseInt(year) >= currentYearLastTwoDigits
            return isMonthValid && isYearValid
                ? (this.validateRules.expDate = false)
                : (this.validateRules.expDate = true)
        },
        validationPass(obj) {
            for (const key in obj) {
                if (obj[key]) {
                    return false
                }
            }
            return true
        },
        getLastFour() {
            this.cardInfo.last_four = this.cardInfo.cardNumber.slice(-4)
        },
        prepareCardNumber(cardNumber) {
            if (cardNumber.length > 19) return cardNumber.replace(/\s/g, '')
            else return cardNumber
        }
    }
}
